/**
 * @flow
 * @file Constants for the i18n components
 * @author Box
 */

/* ------------------ Javascript Object Types ----------------- */
export const JSTYPE_BOOLEAN = 'boolean';
export const JSTYPE_FUNCTION = 'function';
export const JSTYPE_NUMBER = 'number';
export const JSTYPE_OBJECT = 'object';
export const JSTYPE_STRING = 'string';
export const JSTYPE_SYMBOL = 'symbol';
export const JSTYPE_UNDEFINED = 'undefined';

/* ------------------ Plural Category Names For react-intl ----------------- */
export const CATEGORY_ZERO: 'zero' = 'zero';
export const CATEGORY_ONE: 'one' = 'one';
export const CATEGORY_TWO: 'two' = 'two';
export const CATEGORY_FEW: 'few' = 'few';
export const CATEGORY_MANY: 'many' = 'many';
export const CATEGORY_OTHER: 'other' = 'other';
